import React, { useMemo } from 'react';

export const Waveform = ({ isPlaying = false, progress = 0, duration = 0, bars = 64, onSeek, seekable = false, peaks = null }) => {
  // If real analysis peaks are provided, downsample them into the requested bar count.
  // Otherwise fall back to a deterministic pattern so old posts still render nicely.
  const heights = useMemo(() => {
    if (Array.isArray(peaks) && peaks.length > 0) {
      const arr = [];
      const ratio = peaks.length / bars;
      for (let i = 0; i < bars; i++) {
        const start = Math.floor(i * ratio);
        const end = Math.max(start + 1, Math.floor((i + 1) * ratio));
        let mx = 0;
        for (let j = start; j < end && j < peaks.length; j++) mx = Math.max(mx, peaks[j]);
        arr.push(Math.max(0.08, Math.min(1, mx)));
      }
      return arr;
    }
    const arr = [];
    for (let i = 0; i < bars; i++) {
      const v = Math.abs(
        Math.sin(i * 0.4) * 0.5 +
        Math.sin(i * 0.23 + 1) * 0.3 +
        Math.sin(i * 0.07) * 0.2
      );
      arr.push(Math.max(0.15, Math.min(1, v)));
    }
    return arr;
  }, [bars, peaks]);

  const playedRatio = duration > 0 ? progress / duration : 0;

  const handleClick = (e) => {
    if (!seekable || !onSeek || !duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    onSeek(ratio * duration);
  };

  return (
    <div
      className={`w-full h-16 flex items-center gap-[2px] rounded-lg overflow-hidden bg-black/40 p-2 ${seekable ? 'cursor-pointer' : ''} ${isPlaying ? 'wave-playing' : ''}`}
      onClick={handleClick}
      data-testid="waveform"
    >
      {heights.map((h, i) => {
        const played = i / bars < playedRatio;
        return (
          <div
            key={i}
            className={`wf-bar flex-1 ${played ? 'played' : ''}`}
            style={{
              height: `${h * 100}%`,
              animationDelay: `${i * 20}ms`,
              minHeight: '3px',
            }}
          />
        );
      })}
    </div>
  );
};

export default Waveform;
